import { render, staticRenderFns } from "./AddPermissionCategorie.vue?vue&type=template&id=b75fa384"
import script from "./AddPermissionCategorie.vue?vue&type=script&lang=js"
export * from "./AddPermissionCategorie.vue?vue&type=script&lang=js"
import style0 from "./AddPermissionCategorie.vue?vue&type=style&index=0&id=b75fa384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports